import { Status as ChecklistDecision } from '.';

export const mapDecisionToStatus = (
  decision: keyof typeof ChecklistDecision | null,
): ChecklistDecision => {
  switch (decision) {
    case 'Approved':
    case 'Completed':
      return ChecklistDecision.Approved;
    case 'Reject':
    case 'Rejected':
      return ChecklistDecision.Rejected;
    case 'AutoApproved':
      return ChecklistDecision.AutoApproved;
    case 'ApprovedWithException':
      return ChecklistDecision.ApprovedWithException;
    case 'Override':
    case 'Overridden':
      return ChecklistDecision.Overridden;
    case 'Offered':
      return ChecklistDecision.Offered;
    default:
      return ChecklistDecision.AwaitingDecision;
  }
};
